/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiExternalApplication, ApiPermission, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of ApplicationsController.
 */
export class ApplicationsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /applications/{applicationId}:block
     */
    public blockApplication(applicationId: string): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>(`/applications/${applicationId}:block`, undefined);
    }

    /**
     * Calls POST /applications/{applicationId}:unblock
     */
    public unblockApplication(applicationId: string): Promise<Result<boolean>> {
        return this.http.post<Result<boolean>, undefined>(`/applications/${applicationId}:unblock`, undefined);
    }

    /**
     * Calls GET /applications/{applicationId}/permissions
     */
    public getUserPermissions(applicationId: string): Promise<Result<ApiPermission[]>> {
        return this.http.get<Result<ApiPermission[]>>(`/applications/${applicationId}/permissions`);
    }

    /**
     * Calls POST /applications:prefill
     */
    public createPrefilled(): Promise<Result<ApiExternalApplication>> {
        return this.http.post<Result<ApiExternalApplication>, undefined>('/applications:prefill', undefined);
    }

    /**
     * Calls POST /applications/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiExternalApplication>>> {
        return this.http.post<Result<LockedContextDto<ApiExternalApplication>>, undefined>(`/applications/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /applications/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiExternalApplication>> {
        return this.http.post<Result<ApiExternalApplication>, undefined>(`/applications/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /applications/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiExternalApplication[]>> {
        return this.http.post<Result<ApiExternalApplication[]>, string[]>('/applications/locks', ids);
    }

    /**
     * Calls POST /applications/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/applications/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /applications/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/applications/${primaryId}/locks`);
    }

    /**
     * Calls GET /applications/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiExternalApplication>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiExternalApplication>>(`/applications/${primaryId}`, query);
    }

    /**
     * Calls POST /applications
     */
    public add(dto: ApiExternalApplication): Promise<Result<ApiExternalApplication>> {
        return this.http.post<Result<ApiExternalApplication>, ApiExternalApplication>('/applications', dto);
    }

    /**
     * Calls PUT /applications/{primaryId}
     */
    public update(dto: ApiExternalApplication, primaryId: string): Promise<Result<ApiExternalApplication>> {
        return this.http.put<Result<ApiExternalApplication>, ApiExternalApplication>(`/applications/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /applications
     */
    public putRange(dtos: ApiExternalApplication[]): Promise<Result<ApiExternalApplication[]>> {
        return this.http.patch<Result<ApiExternalApplication[]>, ApiExternalApplication[]>('/applications', dtos);
    }

    /**
     * Calls DELETE /applications/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/applications/${primaryId}`);
    }

    /**
     * Calls POST /applications:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiExternalApplication>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiExternalApplication>>, ListRequestWithIds>('/applications:batch', listRequest, query);
    }

    /**
     * Calls POST /applications:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiExternalApplication>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiExternalApplication>>, ListRequest>('/applications:query', listRequest, query);
    }

    /**
     * Calls GET /applications:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiExternalApplication>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiExternalApplication>>>('/applications:query', query);
    }
}
